import Particle from '~/modules/game-engine/drawing/interfaces';
import { PlayerNumber } from '~/modules/players/player-number';

import styles from '../styles';

const TTL = 600;
/** How far the glow trails behind the line, in canvas pixels. */
const TRAIL = 80;

/**
 * A line that sweeps across a player's lane when their section ends, in their own colour. Marks
 * the break between one part and the next without drawing attention away from the notes: it fades
 * in and back out over its life, and never reaches full opacity.
 */
export default class SectionTransition implements Particle {
  public finished = false;
  private ttl = TTL;

  constructor(
    private playerNumber: PlayerNumber,
    private baseY: number,
    private height: number,
  ) {}

  public tick = (ctx: CanvasRenderingContext2D, canvas: HTMLCanvasElement, delta: number) => {
    const progress = 1 - this.ttl / TTL;
    // Triangular: up to the halfway point, then back down, so it arrives and leaves gently.
    const alpha = (progress < 0.5 ? progress : 1 - progress) * 2;
    const x = progress * canvas.width;
    const color = styles.colors.players[this.playerNumber]?.text ?? '#ffffff';

    ctx.save();

    ctx.globalAlpha = alpha * 0.4;
    ctx.beginPath();
    ctx.strokeStyle = color;
    ctx.lineWidth = 3;
    ctx.shadowColor = color;
    ctx.shadowBlur = 20;
    ctx.moveTo(x, this.baseY);
    ctx.lineTo(x, this.baseY + this.height);
    ctx.stroke();

    const trailStart = Math.max(0, x - TRAIL);
    const gradient = ctx.createLinearGradient(trailStart, 0, x, 0);
    gradient.addColorStop(0, 'transparent');
    gradient.addColorStop(1, color);
    ctx.fillStyle = gradient;
    ctx.globalAlpha = alpha * 0.15;
    ctx.fillRect(trailStart, this.baseY, x - trailStart, this.height);

    ctx.restore();

    this.ttl -= delta;
    this.finished = this.ttl <= 0;
  };
}
